import { useState, useCallback } from 'react';
import * as api from '../api/client';

/**
 * Manages prompts scoped to a single session.
 * Re-fetches whenever the active session ID changes.
 */
export function usePrompts(activeId) {
  const [prompts, setPrompts] = useState([]);

  const load = useCallback(async (sid) => {
    if (!sid) { setPrompts([]); return; }
    try {
      const data = await api.getSessionPrompts(sid);
      setPrompts(data);
    } catch {
      setPrompts([]);
    }
  }, []);

  const clear = useCallback(() => setPrompts([]), []);

  const save = useCallback(async (content) => {
    if (!activeId) return;
    const prompt = await api.createSessionPrompt(activeId, content);
    setPrompts(prev => [prompt, ...prev]);
    return prompt;
  }, [activeId]);

  const remove = useCallback(async (promptId) => {
    if (!activeId) return;
    await api.deleteSessionPrompt(activeId, promptId);
    setPrompts(prev => prev.filter(p => p.id !== promptId));
  }, [activeId]);

  return { prompts, load, clear, save, remove };
}
